<template>
  <div class="row vs-controls-row align-items-end">
    <div class="col">
      <label for="sb-days" class="mt-2">Subtask count</label>
      <b-form-spinbutton
        v-model="subtaskCount"
        :min="completed + 1"
        :max="50"
        :disabled="completed > 0"
        @change="subtaskCountBroadcast"
      ></b-form-spinbutton>
    </div>
    <div class="col">
      <b-button variant="success" @click="completedBroadcast" :disabled="completed >= subtaskCount">
        {{ subtaskCount - completed }} remain
      </b-button>
    </div>
    <div class="col align-self-end text-right">
      <b-button v-if="completed === subtaskCount" variant="primary" size="sm" @click="next">Next</b-button>
      <b-button variant="secondary" size="sm" @click="reset">Reset</b-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { EventBus } from '../../event-bus';

export default {
  data() {
    return {
      subtaskCount: 10,
      completed: 0,
    };
  },

  computed: {
    ...mapState(['visualScheduleChannel']),
  },

  methods: {
    ...mapMutations(['updateImageRevealerContent']),

    // Check if we should update visual schedule views over ActionCable
    checkRemoteDisplayUpdate() {
      if (this.visualScheduleChannel) {
        this.updateImageRevealerContent(true);
      }
    },

    completedBroadcast() {
      if (this.completed > this.subtaskCount) {
        return;
      }

      this.completed += 1;
      EventBus.$emit('completed-count', this.completed);
      this.checkRemoteDisplayUpdate();
    },

    next() {
      this.completed = 0;
      EventBus.$emit('subtask-next');
      this.checkRemoteDisplayUpdate();
    },

    reset() {
      this.completed = 0;
      EventBus.$emit('subtask-reset');
      this.checkRemoteDisplayUpdate();
    },

    subtaskCountBroadcast() {
      EventBus.$emit('subtask-count', this.subtaskCount);
      this.checkRemoteDisplayUpdate();
    },
  },
};
</script>
